import { useNavigate } from "react-router-dom";
import { Hourglass } from "lucide-react";

export const trialDaysLeft = (sub) =>
  sub?.trial_until ? Math.max(0, Math.ceil((new Date(sub.trial_until) - new Date()) / 86400000)) : 0;

export function TrialBanner({ sub, className = "" }) {
  const navigate = useNavigate();
  const days = trialDaysLeft(sub);
  const expired = !!sub?.trial_expired;
  if (!expired && !(sub?.trial && days <= 3)) return null;
  const end = new Date(sub.trial_until).toLocaleDateString("fr-FR");
  return (
    <button onClick={() => navigate("/abonnement")} data-testid={expired ? "trial-expired-banner" : "trial-reminder-banner"}
      className={`w-full flex items-center gap-3 rounded-3xl bg-amber-50 border border-amber-300 px-5 py-4 text-left hover:bg-amber-100 transition-colors ${className}`}>
      <Hourglass className="w-6 h-6 text-amber-600 shrink-0" />
      <span className="text-amber-900 font-semibold">
        {expired
          ? `Votre essai gratuit de 7 jours s'est terminé le ${end}. Vos données sont conservées : choisissez une formule pour retrouver l'espace Soignant & Patient.`
          : `Votre essai gratuit se termine le ${end} (${days <= 1 ? "dernier jour" : `dans ${days} jours`}).`}
        <span className="underline ml-1">Choisir une formule</span>
      </span>
    </button>
  );
}
